import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// 引入页面组件
import Home from './pages/home/Home.js';

import './App.css';
import './assets/fonts/iconfont.css';
import './assets/style/mediaquery.scss'

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<Home />} />
            </Routes>
        </Router>
    );
}

export default App;
